import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Form, Select, Checkbox,
  Input, Switch, Radio, Upload, Button,
} from 'antd';
import validate from './validate';
import RichTextArea from '../../../coms/rich/RichTextArea';
import DetailTable from './DetailTable';
import util from "../../../util";

const {
  getAccessToken
} = util;

const {
  normFile,
  checkLen,
  checkFileLen,
  checkDouble,
  checkTable,
} = validate;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form-step',
  }
  render() {
    const {
      prefixCls, formRequiredClass, form, devStore: { genre, genreModule },
    } = this.props;
    let { devStore: { appDetail, currentStatus } } = this.props;
    appDetail = toJS(appDetail);
    currentStatus = parseInt(currentStatus, 10);
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const role = !!localStorage.me ? JSON.parse(localStorage.me).role : "";
    let allDisabled = currentStatus > 1;
    if (role === 'admin' && currentStatus === 2) {
      allDisabled = false;
    }
    if (role === 'admin' && currentStatus === 1) {
      allDisabled = true;
    }
    let betaDisabled = allDisabled;
    if (currentStatus === 3) {
      betaDisabled = true;
    }

    const { getFieldValue, isFieldValidating, getFieldProps, getFieldError } = form;
    return (
      <div className={`${prefixCls}`}>
        <FormItem
          label="适用行业："
          {...formItemLayout}
          className={formRequiredClass}
          hasFeedback={getFieldValue('s_trade') !== "" && !allDisabled}
          help={isFieldValidating('s_trade') ? '校验中...' : (getFieldError('s_trade') || []).join(', ')}>
          <Select mode="multiple" {...getFieldProps("s_trade", {
            rules: [{ validator: checkLen }]
          })} optionFilterProp="search" disabled={allDisabled}>
            {
              toJS(genre) && toJS(genre).map(v => (
                <Select.Option key={v.key} value={v.key} search={v.name}>{v.name}</Select.Option>
              ))
            }
          </Select>
        </FormItem>
        <FormItem
          label="相关模块："
          {...formItemLayout}
          className={formRequiredClass}
          hasFeedback={getFieldValue('s_type') !== "" && !allDisabled}
          help={isFieldValidating('s_type') ? '校验中...' : (getFieldError('s_type') || []).join(', ')}>
          <Select mode="multiple" {...getFieldProps("s_type", {
            rules: [{ validator: checkLen }]
          })} optionFilterProp="search" disabled={allDisabled}>
            {
              toJS(genreModule) && toJS(genreModule).map(v => (
                <Select.Option key={v.key} value={v.key} search={v.name}>{v.name}</Select.Option>
              ))
            }
          </Select>
        </FormItem>
        <FormItem
          label="设备支持："
          {...formItemLayout}
          className={formRequiredClass}
        >
          <CheckboxGroup
            {...getFieldProps('s_apptype',
              {
                initialValue: ['PC'],
                rules: [{ validator: checkLen }]
              })}
            options={['PC', 'MOBILE']}
            disabled={allDisabled}
          />
        </FormItem>
        <FormItem
          label="应用类型："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_stype') ? '校验中...' : (getFieldError('s_stype') || []).join(', ')}>
          <CheckboxGroup {...getFieldProps('s_stype',
            {
              initialValue: ['定制'],
              rules: [{ validator: checkLen },]
            }
          )}
            options={['定制', '建模', '非标', '插件']}
            disabled={allDisabled}
          />
        </FormItem>
        <FormItem
          label="浏览器兼容："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_inter') ? '校验中...' : (getFieldError('s_inter') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_inter',
              {
                initialValue: ['IE8', 'IE9', 'IE10', 'IE11', 'chrome'],
                rules: [{ validator: checkLen },]
              })}
            options={['IE8', 'IE9', 'IE10', 'IE11', 'chrome']}
            disabled={allDisabled}
          />
        </FormItem>
        <FormItem
          label="EC兼容："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_ec') ? '校验中...' : (getFieldError('s_ec') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_ec',
              {
                initialValue: ['EC7', 'EC8'],
                rules: [{ validator: checkLen },]
              })}
            options={['EC6', 'EC7', 'EC8']}
            disabled={allDisabled}
          />
        </FormItem>
        <FormItem
          label="EC兼容说明："
          {...formItemLayout}>
          <Input {...getFieldProps('s_ecdesc')} disabled={allDisabled} />
        </FormItem>
        <FormItem
          label="数据库支持："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_database') ? '校验中...' : (getFieldError('s_database') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_database',
              {
                initialValue: ['oracle', 'sqlserver'],
                rules: [{ validator: checkLen },]
              })}
            options={['oracle', 'sqlserver']}
            disabled={allDisabled}
          />
        </FormItem>
        <FormItem
          label="是否自行解耦："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_ispersonal') ? '校验中...' : (getFieldError('s_ispersonal') || []).join(', ')}>
          <Switch {...getFieldProps('s_ispersonal')}
            checked={getFieldValue('s_ispersonal')}
            disabled={betaDisabled}
          />
        </FormItem>
        <FormItem
          label="beta版本："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_beta') ? '校验中...' : (getFieldError('s_beta') || []).join(', ')}>
          <Switch {...getFieldProps('s_beta')} checked={getFieldValue('s_beta')}
            disabled={allDisabled} />
        </FormItem>
        <FormItem
          label="版本类型："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_beta') ? '校验中...' : (getFieldError('s_beta') || []).join(', ')}>
          <RadioGroup {...getFieldProps('s_nowversion')} disabled={allDisabled}>
            <Radio value="0">大版本更新</Radio>
            <Radio value="1">小版本更新</Radio>
          </RadioGroup>
          <span style={{ "marginLeft": "10px" }}>[系统会自动为你生成版本号]</span>
        </FormItem>
        <FormItem
          label="程序文件："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "appfile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            disabled={allDisabled}
            {...getFieldProps('appfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              initialValue: appDetail.usefile,
              rules: [{ validator: checkFileLen },]
            })}
          >
            <Button type="ghost" icon="upload" disabled={allDisabled}>点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="源码文件："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "srcfile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('srcfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              initialValue: appDetail.srcfile,
              rules: [{ validator: checkFileLen },]
            })
            }
            disabled={allDisabled}>
            <Button type="ghost" icon="upload" disabled={allDisabled}>点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="使用文档："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "usefile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('usefile', {
              valuePropName: 'fileList',
              normalize: normFile,
              initialValue: appDetail.usefile,
              rules: [{ validator: checkFileLen },]
            })
            }
            disabled={allDisabled}>
            <Button type="ghost" icon="upload" disabled={allDisabled}>点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="应用图标："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"}
            data={{access_token: getAccessToken()}}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            accept="image/*"
            listType="picture" data={{ type: "logofile" }}
            {
            ...getFieldProps('logofile', {
              valuePropName: 'fileList',
              normalize: normFile,
              initialValue: appDetail.logofile,
              rules: [{ validator: checkFileLen },]
            })
            }
            disabled={allDisabled}
          >
            { !(getFieldValue('logofile') && getFieldValue('logofile').length > 0) && (<Button type="ghost" icon="upload" disabled={allDisabled}>点击上传</Button>)}
            <span style={{ "marginLeft": "20px" }}><a href="ui/file/imgs.rar" target="_blank">[点击下载参考图标，高270、宽270]</a></span>
          </Upload>
        </FormItem>
        <FormItem
          label="缩略图："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "s_docfile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            accept="image/*"
            listType='picture'
            {
            ...getFieldProps('sDocfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })
            }
          >
            { !(getFieldValue('sDocfile') && getFieldValue('sDocfile').length > 0) && ( <Button type="ghost" icon="upload">点击上传</Button>)}
          </Upload>
        </FormItem>
        <FormItem
          label="解决方案："
          {...formItemLayout}>
          <Upload action={window.server + "/v1/appfile"} data={{ type: "docfile", access_token: getAccessToken() }}
            disabled={allDisabled}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('docfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              initialValue: appDetail.docfile,
            })
            }
          >
            <Button type="ghost" icon="upload" disabled={allDisabled}>点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="结算价格："
          {...formItemLayout}
          hasFeedback={getFieldValue('s_price') !== "" && !allDisabled}
          help={isFieldValidating('s_price') ? '校验中...' : (getFieldError('s_price') || []).join(', ')}>
          <Input
            {...getFieldProps('s_price', {
              rules: [{ required: true, validator: checkDouble }]
            }
            )}
            disabled={allDisabled} />
        </FormItem>
        <FormItem
          label="建议销售价格："
          {...formItemLayout}
          hasFeedback={getFieldValue('s_tuijianprice') !== "" && !allDisabled}
          help={isFieldValidating('s_tuijianprice') ? '校验中...' : (getFieldError('s_tuijianprice') || []).join(', ')}>
          <Input
            {...getFieldProps('s_tuijianprice', {
              rules: [{ required: true, validator: checkDouble }]
            }
            )}
            disabled={allDisabled} />
        </FormItem>
        <FormItem
          label="详细描述："
          {...formItemLayout}
          help={isFieldValidating('s_desc') ? '校验中...' : (getFieldError('s_desc') || []).join(', ')}
        >
          <RichTextArea className={formRequiredClass} {...getFieldProps('s_desc', {
            initialValue: appDetail.s_desc,
            rules: [{ validator: checkLen }]
          })} />
        </FormItem>
        <FormItem
          label="更新日志："
          {...formItemLayout}
          help={isFieldValidating('s_versiondesc') ? '校验中...' : (getFieldError('s_versiondesc') || []).join(', ')}
        >
          <RichTextArea className={formRequiredClass} {...getFieldProps('s_versiondesc', {
            initialValue: appDetail.s_versiondesc,
            rules: [{ validator: checkLen }]
          })} />
        </FormItem>
        <FormItem
          label="Git@OSC账号："
          hasFeedback={getFieldValue('s_svnacc') !== "" && !allDisabled}
          help={isFieldValidating('s_svnacc') ? '校验中...' : (getFieldError('s_svnacc') || []).join(', ')}
          {...formItemLayout}
          className={formRequiredClass}
        >
          <Input
            style={{ width: 220 }}
            {...getFieldProps('s_svnacc',
              {
                rules: [{ validator: checkLen },]
              }
            )}
            disabled={allDisabled} />
          <a href="http://git.oschina.net/" target="_blank" rel="noopener noreferrer" style={{ position: 'absolute', width: '100%', paddingLeft: 15 }}>[点击链接到注册地址，用于代码管理]</a>
        </FormItem>
        <FormItem
          label="PC页面："
          {...formItemLayout}
          className={`dev-left-label`}
          help={isFieldValidating('page') ? '校验中...' : (getFieldError('page') || []).join(', ')}>
          <DetailTable className={formRequiredClass} {
            ...getFieldProps("page",
              { rules: getFieldValue('s_apptype').indexOf("PC") >= 0 ? [{ required: true, validator: checkTable }] : [{ validator: (rule, value, callback) => { callback(); } }] }
            )
          } showData={appDetail.s_apptype && appDetail.s_apptype.indexOf("PC") >= 0}
            onChange={(value) => {
              form.setFieldsValue({
                page: value,
              });
            }} disabled={allDisabled} appType="PC" />
        </FormItem>
        <FormItem
          label="MOILE页面："
          {...formItemLayout}
          className={`dev-left-label`}
          help={getFieldValue('s_apptype') && getFieldValue('s_apptype').indexOf("MOBILE") >= 0 && isFieldValidating('pageMobile') ? '校验中...' : (getFieldError('pageMobile') || []).join(', ')}>
          <DetailTable className={formRequiredClass} {
            ...getFieldProps("pageMobile",
              { rules: getFieldValue('s_apptype').indexOf("MOBILE") >= 0 ? [{ required: true, validator: checkTable }] : [{ validator: (rule, value, callback) => { callback(); } }] }
            )
          } showData={appDetail.s_apptype && appDetail.s_apptype.indexOf("MOBILE") >= 0}
            onChange={(value) => {
              form.setFieldsValue({
                pageMobile: value,
              });
            }} disabled={allDisabled} appType="MOBILE" />
        </FormItem>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form.js